// Get targeting mode messages for UI display
function getTargetingMessage(
  deployTargetMode,
  selectedDeployOrderId,
  deployTargetInfo,
  error,
  strategemTargetMode,
  selectedStrategemId,
  strategemTargetInfo
) {
  if (deployTargetMode && selectedDeployOrderId && !error) {
    return {
      show: true,
      message: `Select a target for ${deployTargetInfo?.order?.name || 'unit'}`,
      type: 'deploy'
    };
  }
  if (strategemTargetMode && selectedStrategemId && !error) {
    const verb = strategemTargetInfo?.type === 'zone' ? 'zone' : 'target';
    return {
      show: true,
      message: `🎯 Strategem Targeting Mode: Select a ${verb} for ${strategemTargetInfo?.strategemName || 'strategem'}`,
      type: 'strategem'
    };
  }
  
  return {
    show: false,
    message: '',
    type: null
  };
}

export default getTargetingMessage;
